import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import 'prophesier'

//import routes from './routes';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import App from './containers/App';
//import Discover from './components/Discover'
import Home from './components/Home';
import Workflow from './components/Workflow'
//import Deeplearn from './components/Deeplearn';
import NotFound from './components/NotFound';
import Estilo from './Estilo';


import './styles/grommet-hpe.min.css';

//
import registerServiceWorker from './registerServiceWorker';

import Custom from "./users/Custom.js"

//import './index.css';

//const middleware = [ thunk ];
//middleware.push(createLogger());

//import injectTapEventPlugin from 'react-tap-event-plugin';
//injectTapEventPlugin();


//let store = configureStore();

//For custom views
/* 
if (window.path === /custom) {
    ReactDOM.render(custom)
} else {
    Below
} */

ReactDOM.render(

        <Router>
            
            <App>
                <Switch>
                    <Route key={'1'} exact={true} path="/" component={Workflow} />
                    {/* <Route key={'2'} exact={true} path="/workflow" component={Workflow} />
                    <Route key={'3'} exact={true} path="/developer" component={Estilo} />

                    <Route key={'4'} exact={true} path="/custom" component={Custom} />    */}
                    {/* <Route key={'2'} exact={true} path="/contact" component={Home} />
                    
                    <Route key={'5'} exact={true} path="/deeplearn" component={Deeplearn} /> */}
                    <Route key={'3'} path="*" component={NotFound} />
                </Switch>
            </App>
            
        </Router>, document.getElementById('root'));


registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js